import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getLadrones, updateLadron, insertLadron, deleteLadron } from 'services/ventas'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_LADRONES() {
  try {
    const ladronesData = yield call(getLadrones)
    if (ladronesData.ok) {
      yield put({
        type: actions.LADRONES_LOAD_SUCCEEDED,
        payload: ladronesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar ladrones')
      put({
        type: actions.LADRONES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.LADRONES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_LADRON(action) {
  try {
    const ladronObj = yield call(insertLadron, action.payload)
    if (ladronObj.ok) {
      putMessage(messageType.SUCCESS, 'Ladrón creado correctamente')
      yield put({
        type: actions.LADRON_INSERT_SUCCEEDED,
        payload: ladronObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Ladrón')
      yield put({
        type: actions.LADRON_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Ladrón')
    yield all([
      put({
        type: actions.LADRON_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_LADRON(action) {
  try {
    const ladronObj = yield call(updateLadron, action.payload)
    if (ladronObj.ok) {
      putMessage(messageType.SUCCESS, 'Ladrón modificado correctamente')
      yield put({
        type: actions.LADRON_UPDATE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Ladrón')
      yield put({
        type: actions.LADRON_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Ladrón')
    yield all([
      put({
        type: actions.LADRON_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_LADRON(action) {
  try {
    const ladronResult = yield call(deleteLadron, action.payload)
    if (ladronResult.ok) {
      putMessage(messageType.SUCCESS, 'Ladrón eliminado correctamente')
      yield put({
        type: actions.LADRON_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Ladrón')
      yield put({
        type: actions.LADRON_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Ladrón')
    yield all([
      put({
        type: actions.LADRON_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LADRONES_LOAD_REQUESTED, GET_LADRONES),
    takeEvery(actions.LADRON_INSERT_REQUESTED, INSERT_LADRON),
    takeEvery(actions.LADRON_UPDATE_REQUESTED, UPDATE_LADRON),
    takeEvery(actions.LADRON_DELETE_REQUESTED, DELETE_LADRON),
  ])
}
